import './App.css';

import Section from './Components/section.js'
import Card from './Components/card.js'

import {Advice,General,Brutal,Educational,Motivational,Technique,TimeManagement,Mental,Resource,LongTerm} from './Components/tag.js'

function App() {
  return (
    <div style={{display:"flex",flexDirection:"column"}}>
      <div id="Navbar">
        <h1 id="NavbarHeader">How Study</h1>
        <h1 id="NavbarGithub">github.com/asimno</h1>
      </div>
      <div id="Main">
        <Section header="Advice"
        content={
            <>
              <Card
                header="Take a break"
                tags={<><Advice/><Mental/></>}
                description="Consider, are you burnt out? If you think so, the absolute best method to dealing with burnout is to simply take a break. Dedicate some time for yourself, where you don't have to worry about anything and can just relax and do stuff you enjoy. It might be hard to find that time when things get especially busy, but please remind yourself that your mental and physical health is far more important than whatever needs to be done and plays a huge part in how well you can work."
                links={<><p>Are you burnt out: https://www.nuffieldhealth.com/article/what-is-burnout-signs-symptoms-and-coping-strategies</p><p>Make the most of your break: https://www.nhs.uk/mental-health/self-help/guides-tools-and-activities/tips-to-reduce-stress/</p></>}
              />
            </>
          }
        />
        <Section header="Techniques"
        content={
            <>
              <Card
                header="Pomodoro Technique"
                tags={<><Technique/><Resource/><TimeManagement/></>}
                description="Divide study sessions into numerous 25 minute focus periods with a 5 minute break period (25-5), taking a 30 minute break after 5 sessions. If that doesn't suit you try out other Pomodoro styles such as (50-10) or (90-30)."
                links={<><p>Useful Pomodoro Website: https://pomofocus.io/</p></>}
              />
              <Card
                header="Do it for 5 minutes"
                tags={<><Technique/><Motivational/></>}
                description="Sit down and do that thing you need to do for 5 minutes, then take a break. Easy, right? 9 times out of 10 you won't mind continuing for longer as 5 minutes is enough time to enter a 'focus state'. Combine this with the Pomodoro technique and ease into it with progessively longer focus periods."
                links={<></>}
              />
              <Card
                header="Study Space"
                tags={<><Technique/><Mental/><LongTerm/></>}
                description="Find a quiet, distraction-free and accessible place to call your 'study space', a place you ONLY go to when you work. This can be at home or outside like a library or a cafe, the point is over time you will associate this environment with being productive. This can help if you struggle to study in your room or anywhere noisy/distracting."
                links={<></>}
              />
            </>
          }
        />
        <Section header="Resources"
        content={
            <>
              <Card
                header="Google Calendar / Google Tasks"
                tags={<><Resource/><TimeManagement/></>}
                description="Free calendar, time-management and to-do list service to help you organize your day and keep track of what needs done and when. Ideal if you already have a Google account."
                links={<>
                  <p>Link to Google Calendar: https://calendar.google.com</p>
                  <p>Link to Google Tasks: https://tasks.google.com</p>
                </>}
              />
              <Card
                header="Knowt"
                tags={<><Resource/><Educational/></>}
                description="Really great, free alternative to Quizlet. Has flashcards, lessons, practice tests, and minigames where you can learn your desired topic."
                links={<><p>Link to Knowt: https://knowt.com</p></>}
              />
            </>
          }
        />
      </div>
      <div id="Footer">
        <p class="NavbarText">Keep in mind, different advice will work for different people at different times! Many of these may be of use to you, or none may be of use to you. I encourage you to check in every now and then whenever you're struggling to study and experiment with what works in the moment.</p>
        <p class="NavbarText">Future Features:</p>
          <ul class="NavbarText">
            <p>Filter by Tags</p>
            <p>Filter by Specific Problems</p>
          </ul>
        <p class="NavbarText">Made by github.com/asimno in a couple hours, will update this whenever I can</p>
      </div>
    </div>
  );
}

//Bunch of cards, can be reused
//https://calendar.google.com

export default App;
